import byPageMaker from 'reducersMakers/byPageMaker';
import * as actions from 'actions';

export default byPageMaker([actions.CHAT_RESOURCES_FETCH_SUCCESS], 'chatResourcesIds');



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatResources/byPage/reducer.js
 **/